// export const AUTHREDUCER = (state = { isAuth: false, user: {} }, action) => {
//   switch(action.type) {
//     case 'LOGIN_REQUEST':
//       return {
//         isAuth: 'in-process',
//         user: {}
//       };
//     case 'LOGIN_SUCCESS':
//       return {
//         isAuth: true,
//         user: action.data
//       };
//     case 'LOGIN_FAILURE':
//       return {
//         isAuth: false,
//         user: {}
//       };
//     case 'LOGOUT':
//       return {
//         isAuth: false,
//         user: {}
//       };
//     case 'RESET_AUTH_REUCER':
//       return state;
//     default:
//       return state;
//   }
// };
const initialState = { ISAUTH: false, ISAUTHATTEMPT: false, USER: {} };

export const LOGINREDUCER = (state = initialState, action) => {
  switch (action.type) {
    case 'LOGIN_REQUEST':
      return {
        ...state,
        ISAUTHATTEMPT: true
      };
    case 'LOGIN_SUCCESS':
      return {
        ISAUTHATTEMPT: false,
        ISAUTH: true,
        USER: action.data
      };
    case 'LOGIN_FAILURE':
      return initialState;
    case 'LOGOUT_SUCCESS':
      return initialState;
    case 'LOGOUT_FAILURE':
      return {
        ...state,
        ISAUTHATTEMPT: false,
      };
    case 'RESET_AUTH_REUCER':
      return initialState;
    default:
      return state;
  }
};


// WEBPACK FOOTER //
// ./src/redux/reducers/Auth/AuthReducer.js